var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 382.53 318.69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 146,
    y1: 26.45,
    x2: 157.8,
    y2: 125.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 277.01,
    y1: 281.3,
    x2: 187.32,
    y2: 285.3,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 227.15,
    y1: -53.31,
    x2: 196.61,
    y2: 511.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 280.56,
    y1: 263.11,
    x2: 167.47,
    y2: 248.23,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 256.93,
    y1: 271.8,
    x2: 161,
    y2: 270.58,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 282.68,
    y1: 271.73,
    x2: 390.76,
    y2: 270.86,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 221.13,
    y1: 261.85,
    x2: 204.04,
    y2: 293.85,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 122.37,
    y1: 253.77,
    x2: 125.19,
    y2: 323.2,
    xlinkHref: "#linear-gradient-2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 197.911,
    y1: 101.972,
    x2: 197.911,
    y2: 210.199,
    id: "gradient-0",
    gradientTransform: "matrix(0.949558, 0.313591, -0.582518, 1.749664, 104.229139, -191.999637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 0.23
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M98.31,16.32C82.43,27.58,68.88,76.78,57.88,92-19.84,199.43,42.5,273.18,70.05,295.39c21.12,17,51.05,22.4,79.52,23.16,47.85,1.27,95.33-8.53,143.2-8.37,25.21.09,52.12,2.6,74-8.48,29.74-15,39-50,35.15-80.26s-17.55-58.95-21.58-89.17c-2.95-22.16-.81-45.46-10.87-65.9-12.81-26-43.38-42.16-74.47-48.7s-63.47-5.16-95.4-6C182.1,11.14,171.05,2,154.25.29,135-1.7,113.07,5.87,98.31,16.32Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#19b24b",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,103.68c-2.59,27.24,4.47,55.2-1.75,81.85-2.19,9.38-6,18.4-7.2,28S63,233.8,70.42,240c4.23,3.51,9.69,5.1,14.5,7.77S94.25,255,94,260.46c-.14,3.28-2,6.41-1.55,9.66.77,5.85,7.83,8.21,13.64,9.26a875.68,875.68,0,0,0,214.09,12c11.88-.8,25.36-2.73,32.09-12.55,6.24-9.12,3.62-22.55-4.45-30.1-2-1.87-4.34-3.52-5.59-6-3.06-6,1.68-12.72,4.8-18.67,7.6-14.52,5.64-32,3.48-48.22-1.18-8.91-2.49-18.16-7.46-25.65-5.09-7.66-13.37-12.49-21.39-17-35.55-20-71.91-39-110.7-51.62C173.88,69.56,77,42.07,71.15,103.68Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#19b24b",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187,39.89H111.53A21.72,21.72,0,0,0,89.8,61.61v47.67H216.56V64.41Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#19b24b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187,39.89H111.53A21.72,21.72,0,0,0,89.8,61.61v47.67H216.56V64.41Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.52,
    y: 65.36,
    width: 256.8,
    height: 179.73,
    rx: 28.3,
    fill: "#19b24b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5,274.24H98.31c-2.88,0-15.62-1.64-15.62-3.65h0c0-2,12.74-3.64,15.62-3.64H264.5Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.78,269.87v2.49A15.77,15.77,0,0,1,339,288.11H240.77a15.79,15.79,0,0,1-15.13-11.31,15.48,15.48,0,0,1-.65-4.44v-2.49a15.22,15.22,0,0,1,1.56-6.75,15.72,15.72,0,0,1,14.22-9H339A15.78,15.78,0,0,1,354.78,269.87Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#19b24b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.41,284v4.16H240.77a15.79,15.79,0,0,1-15.13-11.31,15,15,0,0,1,3.42-.59S233.5,284,239.24,284Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.28,262.36v16.11a4.4,4.4,0,0,1-3.72,4.37,3.17,3.17,0,0,1-.69.07,4.44,4.44,0,0,1-4.44-4.44V262.36a4.46,4.46,0,0,1,4.44-4.44,3.17,3.17,0,0,1,.69.07A4.42,4.42,0,0,1,219.28,262.36Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "#19b24b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.09,259.2s-53.65-.69-59.91,0-9.71,8.33-9.71,8.33a19,19,0,0,1-1.92-4.41,15.72,15.72,0,0,1,14.22-9h57Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "url(#linear-gradient-4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 196.09,
    y: 262.81,
    width: 18.74,
    height: 15.61,
    fill: "#19b24b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 206.67,
    y: 268.37,
    width: 65.23,
    height: 6.42,
    rx: 3.21,
    fill: "url(#linear-gradient-5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 269.3,
    y: 268.37,
    width: 65.23,
    height: 6.42,
    rx: 3.21,
    fill: "url(#linear-gradient-6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.28,262.36v16.11a4.4,4.4,0,0,1-3.72,4.37V258A4.42,4.42,0,0,1,219.28,262.36Z",
    transform: "matrix(1, 0, 0, 1, -20.24, 0.03)",
    fill: "url(#linear-gradient-7)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "83.5 266.98 79.16 262.99 56.09 266.11 56.09 273.74 76.91 277.73 83.33 273.92 83.5 266.98",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.19 271.66 82.46 271.49 75.17 274.7 56.49 272.64 56.09 273.74 76.91 277.73 82.72 274.26 190.19 274.61 190.19 271.66",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 203.685 160.502 L 191.66 160.502 L 191.66 124.426 L 203.685 124.426 M 191.66 172.527 L 203.685 172.527 L 203.685 184.553 L 191.66 184.553 M 220.1 100.376 L 175.246 100.376 L 143.559 132.062 L 143.559 176.917 L 175.246 208.603 L 220.1 208.603 L 251.787 176.917 L 251.787 132.062 L 220.1 100.376 Z",
    style: {
      fill: "url(#gradient-0)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2025887ba710b6ad8fe7764a99fe2b4f.svg";
export { ForwardRef as ReactComponent };